import ngRedux from 'ng-redux'
import { IPromise } from 'angular'
import { SaleManager } from '../../../managers/sale-manager'
import {
  ReduxCurrentSale,
  selectCurrentSale,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { RootState } from '../../../state/store'
import { isConfirmed, PromotionSummaryItem } from '../../../functions/sale'

/**
 * Controller for the sale-promotion popover.
 *
 * @class SalePromotionPopoverController
 */
export class SalePromotionPopoverController {
  public promotionsList: PromotionSummaryItem[]
  public currentSale: ReduxCurrentSale
  constructor(
    public close: (options?: {
      match: string | Node | JQLite
    }) => IPromise<void>,
    public saleManager: SaleManager,
    private $ngRedux: ngRedux.INgRedux,
    private $scope: angular.IScope
  ) {
    'ngInject'
    this.currentSale = selectCurrentSale(this.$ngRedux.getState()) // populating an initial value so that it's never undefined, and then updates to the sale can be handled by connect so we're not left with a stale valua
    const disconnectRedux = this.$ngRedux.connect((state: RootState) => ({
      currentSale: selectCurrentSale(state),
    }))(this)
    this.promotionsList = this.saleManager.getPromotionSummary()
    this.$scope.$on('$destroy', disconnectRedux)
  }

  /**
   * Determine whether promo code remove button should be hidden based on sale state.
   *
   * @method isPromoCodeDeleteDisabled
   * @return {Boolean} true if should show the promo code remove button
   */
  public isPromoCodeDeleteDisabled() {
    return Boolean(
      this.currentSale.returnFor ||
        isConfirmed(this.currentSale) ||
        this.currentSale.isSavedUnfulfilled
    )
  }

  /**
   * Remove added promo code from the sale
   *
   * @method removePromoCode
   */
  public removePromoCode() {
    this.saleManager.addOrRemovePromoCode('').then(() => this.close())
  }
}
